import {NgModule} from '@angular/core';
import {LmConfigPage} from "./page/overview/lm-config/lm-config.page";
import {LmDashboardPage} from "./page/overview/lm-dashboard/lm-dashboard.page";
import {LM_ENTITY_PROVIDER} from "./lm.entity-provider";
import {CoreModule} from "../../core/core.module";
import {LM_TEST_PROVIDERS} from "./test/lm-test-definition";
import {
    LmLeadInlineComponent
} from "./component/protected-components/lm-lead-inline-component/lm-lead-inline-component";
import {
    LmLeadObjectComponent
} from "./component/protected-components/object-somponents/lm-lead-object-component/lm-lead-object.component";
import {
    LmLeadBaseComponent
} from "./component/protected-components/object-somponents/lm-lead-object-component/view/lm-lead-base.component";
import {
    LmLeadSideComponent
} from "./component/protected-components/object-somponents/lm-lead-object-component/view/lm-lead-side-component/lm-lead-side.component";
import {
    LmLeadInlineViewComponent
} from "./component/protected-components/object-somponents/lm-lead-object-component/view/lm-lead-inline-view-component/lm-lead-inline-view.component";
import {
    LmLeadFullComponent
} from "./component/protected-components/object-somponents/lm-lead-object-component/view/lm-lead-full-component/lm-lead-full.component";


@NgModule({
  declarations: [
    LmConfigPage,
    LmDashboardPage,
    LmLeadInlineComponent,
    LmLeadObjectComponent,
    LmLeadBaseComponent,
    LmLeadSideComponent,
    LmLeadInlineViewComponent,
    LmLeadFullComponent,
  ],
  exports:[
    LmConfigPage,
    LmDashboardPage,
  ],
  imports: [
    CoreModule,

  ],
  providers: [LM_ENTITY_PROVIDER, LM_TEST_PROVIDERS]
})
export class LmModule { }
 
 
 
